import React from "react";
import { Table, RaisedButton, FlatButton, IconButton } from "material-ui";
import { IS_MOBILE, formatPrice } from "../../util";
import { colors as Colors } from "material-ui/styles";

import AddShoppingCartIcon from "material-ui/svg-icons/action/add-shopping-cart";

import OrderActions from "../../actions/OrderActions";

import BaseOverlay from "../overlays/base.jsx";

import LinkLike from "./link-like.jsx";

import Tooltip from "./tooltip.jsx";

class OrderActionButtons extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      hovered: false,
      reconfirmShown: false
    };

    this.addToCart = this.addToCart.bind(this);
  }

  static contextTypes = {
    muiTheme: React.PropTypes.object,
    tenant: React.PropTypes.object
  };

  addToCart() {
    OrderActions.pushCurrentOrderToCart();
    this.props.onForceCancel();
  }

  getStyles() {
    return {
      actions: {
        marginTop: 20
      }
    };
  }

  render() {
    var styles = this.getStyles(),
      { buyTooltip, order } = this.props,
      quantity = order.subitems.reduce((c, i) => c + (i.quantity || 0), 0);

    if (this.props.onlyCartSlim) {
      return (
        <LinkLike disabled={this.props.disabled} onClick={this.addToCart}>
          Add to cart
        </LinkLike>
      );
    }

    var renderedBuyLabel = `${
      this.props.buyLabel || (order.gift ? "Gift" : "Buy")
    }${this.props.canAddToCart ? " now" : ""} (${formatPrice(order.total)})`;

    return (
      <div style={styles.actions}>
        {this.state.reconfirmShown ? (
          <BaseOverlay
            zIndex={3001}
            onRequestClose={() => this.setState({ reconfirmShown: false })}
            contentStyle={{ maxWidth: 700, zIndex: 3002 }}
          >
            <div style={{ textAlign: "center", padding: 10 }}>
              <div style={{ fontSize: "1.5em", lineHeight: 1.25 }}>
                Your <strong>{this.props.person.payment_method_summary}</strong>{" "}
                will immediately be charged{" "}
                <strong>{formatPrice(order.total)}</strong>.
              </div>
              <div style={{ marginTop: "1.25em" }}>
                <RaisedButton
                  label="Back"
                  onClick={() => this.setState({ reconfirmShown: false })}
                  style={{ marginRight: "1em" }}
                />
                <RaisedButton
                  label={renderedBuyLabel}
                  primary={true}
                  onClick={() => {
                    this.setState({ reconfirmShown: false });
                    this.props.onSubmit();
                  }}
                />
              </div>
            </div>
          </BaseOverlay>
        ) : null}
        <FlatButton
          label={this.props.cancelLabel || "Cancel"}
          onClick={this.props.onCancel}
          style={{ float: "left" }}
          className={"eventive-button eventive-button-cancel"}
        />
        <div style={{ float: "right" }}>
          {this.props.canAddToCart ? (
            <RaisedButton
              label={`Add to cart`}
              disabled={this.props.disabled}
              onClick={this.addToCart}
              className={"eventive-button eventive-button-add-to-cart"}
              style={{ marginRight: 7 }}
            />
          ) : null}
          <RaisedButton
            label={renderedBuyLabel}
            primary={true}
            disabled={this.props.disabled}
            className={"eventive-button eventive-button-buy"}
            onClick={() => {
              if (
                this.props.person &&
                this.context.tenant.checkout_reconfirm_card_over_threshold &&
                order.total >
                  this.context.tenant.checkout_reconfirm_card_over_threshold
              ) {
                this.setState({ reconfirmShown: true });
                return;
              }
              this.props.onSubmit();
            }}
            onMouseEnter={
              !IS_MOBILE
                ? () => {
                    this.setState({ hovered: true });
                  }
                : undefined
            }
            onMouseLeave={
              !IS_MOBILE
                ? () => {
                    this.setState({ hovered: false });
                  }
                : undefined
            }
          >
            {buyTooltip ? (
              <Tooltip
                show={this.state.hovered}
                label={buyTooltip}
                style={{ marginTop: -64, right: 0 }}
                containerStyle={{ right: 0, left: "auto" }}
              />
            ) : null}
          </RaisedButton>
        </div>
      </div>
    );
  }
}

export default OrderActionButtons;



// WEBPACK FOOTER //
// ./src/app/components/partials/order-action-buttons.jsx